import actionTypes from "../actionTypes";
import {INotificacion, IPartnersSections} from "../../types";

const update = require('immutability-helper');


export const initialState = {
    notification: null as null | INotificacion,
    section: 'dashboard' as IPartnersSections,
    cropsense: false as boolean,
    dialogs: {
        crea_promocion: false as boolean
    }
};

export function reducer(state: typeof initialState=initialState, action: actionTypes) {
    switch (action.type) {
        case 'notify-partners':
            return update(state, {notification: {$set: action.notification}});

        case 'select-section-partners':
            return update(state, {section: {$set: action.section}});

        case 'set-cropsense':
            return update(state, {cropsense: {$set: action.cropsense}});

        case 'open-new-promocion-dialog':
            return update(state, {dialogs: {crea_promocion: {$set: action.callback}}});

        default:
            return state
    }
}
